import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const ChevronUpSmall = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M13.7530611,12.2766478 C14.9888771,11.0326503 16,10.0091636 16,10.0022336 C16,9.99530372 15.7813757,9.76982058 15.5141692,9.50115989 L15.0283394,9.01268653 L13.2703168,10.7823337 L11.5122949,12.5519819 L9.74797148,10.775991 L7.98364813,9 L7.49182412,9.4949696 C7.22132081,9.76720268 7,9.99552848 7,10.0023614 C7,10.014535 11.4878975,14.5384615 11.4999747,14.5384615 C11.5033559,14.5384615 12.517245,13.5206452 13.7530611,12.2766478 Z"
            transform="translate(11.500000, 11.769231) rotate(180.000000) translate(-11.500000, -11.769231) "
        ></path>
    </StarryUIIcon>
);
